import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as resourceActions from 'ACTIONS/resources.actions';
import queryString from 'query-string';
import './DataGrid.less';

const DataGridFiltersWrap = (WrappedComponent) => {
  class DataGridFiltersWrapper extends Component {
    handleUpdateData = (resource, params) => {
      this.props.refetchResource(resource, params);
    }
    render() {
      const searchParams = queryString.parse(this.props.search);
      return (
        <div className="data-grid-filters">
          <WrappedComponent
            updateData={this.handleUpdateData}
            searchParams={searchParams}
            clearFilters={this.props.clearFilters}
            {...this.props}
          />
        </div>
      );
    }
  }
  DataGridFiltersWrapper.defaultProps = {
    search: '',
  };
  DataGridFiltersWrapper.propTypes = {
    refetchResource: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    search: PropTypes.string,
  };

  const mapDispatchToProps = dispatch => bindActionCreators(resourceActions, dispatch);
  const mapStateToProps = ({ router }) => ({ search: router.location.search });

  return connect(mapStateToProps, mapDispatchToProps)(DataGridFiltersWrapper);
};

export default DataGridFiltersWrap;



// WEBPACK FOOTER //
// ./src/components/DataGrid/DataGridFiltersWrap.js